module.exports = __webpack_public_path__ + "static/img/组 2844.c2600c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/组 2844.png
// module id = eWIC
// module chunks = 0